import { useState } from "react";
import { Button, Form, Container, Card, Row, Col } from "react-bootstrap";

function Register() {
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [zipCode, setZipCode] = useState("");

    const handleRegister = () => {
        console.log("Nombre completo:", fullName);
        console.log("Email:", email);
        console.log("Contraseña:", password);
        console.log("Teléfono:", phone);
        console.log("Código Postal:", zipCode);
    };

    const handleGoogleRegister = () => {
        console.log("Registrando con Google");
    };

    const handleFacebookRegister = () => {
        console.log("Registrando con Facebook");
    };

    return (
        <Container className="d-flex justify-content-center align-items-center local-hire-design" style={{ minHeight: '100vh' }}>
            <Card className="p-4 shadow-lg border-0 rounded-lg" style={{ maxWidth: '500px', width: '100%' }}>
                <Card.Body>
                    <h2 className="text-center mb-4 text-primary fw-bold">Crear una cuenta</h2>

                    <Row className="mb-3">
                        <Col>
                            <Button
                                variant="outline-danger"
                                className="w-100 mb-2 rounded-pill shadow-sm"
                                onClick={handleGoogleRegister}
                            >
                                <i className="bi bi-google me-2"></i>
                                Registrarse con Google
                            </Button>

                            <Button
                                variant="outline-primary"
                                className="w-100 rounded-pill shadow-sm"
                                onClick={handleFacebookRegister}
                            >
                                <i className="bi bi-facebook me-2"></i>
                                Registrarse con Facebook
                            </Button>
                        </Col>
                    </Row>

                    <div className="text-center text-muted my-3">o completa este formulario</div>

                    <Form>
                        <Form.Group className="mb-3" controlId="formFullName">
                            <Form.Label className="fw-medium">Nombre completo</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingresa tu nombre completo"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label className="fw-medium">Correo electrónico</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Ingresa tu correo"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formPassword">
                            <Form.Label className="fw-medium">Contraseña</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Crea una contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formPhone">
                            <Form.Label className="fw-medium">Teléfono</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingresa tu número de teléfono"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formZipCode">
                            <Form.Label className="fw-medium">Código Postal</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingresa tu código postal"
                                value={zipCode}
                                onChange={(e) => setZipCode(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Button variant="success" type="button" onClick={handleRegister} className="w-100 rounded-pill shadow-sm">
                            Registrarse
                        </Button>
                    </Form>

                    <div className="text-center mt-3">
                        <small className="text-muted">
                            ¿Ya tienes una cuenta? <a href="/login" className="text-primary fw-bold">Inicia sesión</a>
                        </small>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Register;